<template>
  <div></div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import * as types from '@/store/mutation_types'

import {createPopulatedCompanySiteData} from '@/lib/sites'
import {readThemesData} from '@/lib/themes'

export default {
  name: 'create-website',

  props: {
    job: Object,
    template: Object,
    companyId: String,
    siteName: String,
    companyCity: String,
    goToSite: Boolean
  },

  data() {
    return {
      jobStarted: false,
      errors: {},
      themes: [],
      title: 'Create Website',
      siteId: ''
    }
  },

  computed: {
    ...mapGetters(['loading']),
    ...mapState(['whiteLabel']),

    newSiteData() {
      return {
        user_id: this.job.userId,
        company_city: this.companyCity,
        company_phone: this.job.companyPhone,
        site: this.site,
        price: process.env.VUE_APP_STRIPE_MONTHLY_PRICE,
        create_subscription: this.job.createSubscription,
        template: this.template.content,
        is_preview: true
      }
    },

    generatedDomain() {
      let dateNow = Date.now()
      return this.whiteLabel ? `preview-${dateNow}.new-website.co.uk` : `preview-${dateNow}.pagemakerpro.com`
    },

    site() {
      return {
        name: this.siteName,
        active: true,
        domain: this.generatedDomain,
        theme_id: this.themes[0].id, // TODO: make this editable
        background_color: '#205766', // TODO: make this editable
        title_base: this.siteName,
        default_description: this.job.seoDescription
      }
    }
  },

  methods: {
    getData() {
      readThemesData().then(({data}) => {
        this.themes = data
      })
    },

    startJob() {
      this.createSite()
      this.$emit('jobStarted')
    },

    createSite() {
      this.jobStarted = true
      this.$store.commit(types.LOADING, true)

      createPopulatedCompanySiteData(this.newSiteData)
        .then(({data}) => {
          let siteId = data.id
          this.$store.commit(types.LOADING, false)

          if (this.goToSite) {
            this.$router.push({
              name: 'site',
              params: {
                companyId: this.companyId,
                siteId: siteId
              }
            })
          } else {
            this.$router.push({
              name: 'homeContent',
              params: {
                companyId: this.companyId,
                siteId: siteId
              }
            })
          }
        })
        .catch(({response}) => {})
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'

.create-website
  position: fixed
  width: 300px
  height: 100%
  overflow: scroll
  z-index: 4
  top: 0
  right: 0
  background: rgba(255, 255, 255, 0.5)
  padding: 3px
</style>
